<template>
        <div class="modal fade" id="generatingModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$lang("Trwa generowanie pliku...")}}
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: 'generating-modal'
    }
</script>
